import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { VideoAppointmentsApi } from '../api/videoAppointments.api';
import { switchMap, map } from 'rxjs/operators';
import { VideoAppointment, VideoAppointmentsData } from '../../../interfaces/patient-services/videoAppointment';

@Injectable()
export class VideoAppointmentsService extends VideoAppointmentsData {

  constructor(private api: VideoAppointmentsApi) {
    super();
  }


  list(url: string): Observable<any[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<VideoAppointment>{
      return this.api.getById(url);
  }

  create(url: string, data:any): Observable<VideoAppointment> {
    return this.api.add(url,data);
  }



  update(url: string, data:VideoAppointment): Observable<VideoAppointment> {
    return this.api.update(url,data);
  }



  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
